"use client";

import React from "react";
import Link from "next/link";

const AffordableExtractionsIntro: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          At Smile4Me Dental Care, our priority is always preserving your
          natural teeth. But when a tooth is too damaged, infected, or crowded
          to save, a{" "}
          <Link
            href="/blog/will-a-dentist-pull-an-infected-tooth-the-same-day/"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            timely extraction is the most effective
          </Link>{" "}
          way to protect your oral health and the rest of your smile. Dr. Iosif
          Khaimov, a trusted{" "}
          <a
            href="https://maps.google.com/maps?cid=8192593597492375843"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            dentist in Astoria
          </a>{" "}
          with over 7 years of hands-on patient care experience, performs both
          simple and surgical tooth extractions in Astoria Queens, using modern
          techniques and a gentle approach to keep you comfortable from start
          to finish.
        </p>
      </div>
    </section>
  );
};

export default AffordableExtractionsIntro;
